export function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function normalize(text) {
  return String(text || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function glyph(name, colour) {
  const letter = String(name || "?").trim().charAt(0).toUpperCase() || "?";
  const bg = colour ? `#${String(colour).replace(/^#/, "")}` : "#2a5a52";
  return `<span class="glyph" style="--glyph:${escapeHtml(bg)}" aria-hidden="true">${escapeHtml(
    letter
  )}</span>`;
}

export function formatMinutes(mins) {
  if (mins == null) return "";
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m ? `${h}h ${m}m` : `${h}h`;
}
